package com.ervasstudio.tracoemovimento

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.apps
import dev.gitlive.firebase.initialize
import org.jetbrains.compose.web.css.*


@InitKobweb
fun initFirebase(ctx: InitKobwebContext) {
    Firebase.initialize(
        context = null,
        options = FirebaseOptions(
            apiKey = "AIzaSyAOn5_yThIkbnb9Xka28nYNQf-achUzkIc",
            authDomain = "traco-e-movimento.firebaseapp.com",
            projectId = "traco-e-movimento",
            storageBucket = "traco-e-movimento.firebasestorage.app",
            gcmSenderId = "860445658463",
            applicationId = "1:860445658463:web:4fad14ca3c36bf0b4ffaea"
        )
    )
    js("import('firebase/auth').then(function(authModule) { authModule.setPersistence(authModule.getAuth(app), authModule.browserLocalPersistence); })")
}
@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
            content()
        }
    }
}
